import { createAction } from 'redux-actions';

export const trackWantsMoreAlertsSurveyClick = createAction('TRACK_WANTS_MORE_ALERTS_SURVEY_CLICK');
